<!-- 百度 账号 表格 -->
<template>
	<div class="table-box" >
		<!-- 表头 -->
		<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
			<div class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell"
				:style="{'width':30 + 'px'}">
					<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"></a-checkbox>
				</div>
				<template v-for="(item,index) in rableTitle" name="item.type">
					<div v-if="index <= sticky_index" class="table-th-cell" style="cursor: default;"
					:style="{'width':rableTitle[index].width + 'px'}" >
						{{rableTitle[index].title}}
					</div>
				</template>
				
			</div>
			
			<div  v-for="(item,index) in rableTitle" :key="index" >
	
				<div v-if="index > sticky_index && item.show_control" class="table-th-cell" 
				:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default','justify-content': item.text_right?'flex-end':''}"
				@click="sortClick(index)">
					{{item.title}}
					<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
						<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
						<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
					</div>
				</div>
			</div>
			<!-- 占位，隔出一个空白区域 -->
			<div id="" style="padding:15px;"></div>
		</div>
		
		<!-- 总计 -->
		<div v-if="tableShowData.length > 0" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<!-- 选择 -->
				<div class="table-td-cell" :style="{'width':30 + 'px'}">
					
				</div>
				<div class="table-td-cell"
				:style="{'width':rableTitle[0].width + 'px'}">
					总计
				</div>
				<div class="table-td-cell"
				:style="{'width':rableTitle[1].width + 'px'}" >
					
				</div>
				<div  class="table-td-cell"
				:style="{'width':rableTitle[2].width + 'px'}">
					
				</div>
				<div  class="table-td-cell"
				:style="{'width':rableTitle[3].width + 'px'}">
					
				</div>
			</div>
			<!-- 消耗 -->
			<div class="table-td-cell"  :class="{'text-right': rableTitle[4].text_right}" :style="{'width': rableTitle[4].width + 'px'}">
				{{tableSumData.cost || 0}}
			</div>
			<!-- 展示数 -->
			<div v-show="!jj_checked" class="table-td-cell" :class="{'text-right': rableTitle[5].text_right}"  :style="{'width': rableTitle[5].width + 'px'}">
				{{tableSumData.impression || 0}}
			</div>
			<!-- ecpm -->
			<div v-show="!jj_checked" class="table-td-cell" :class="{'text-right': rableTitle[6].text_right}" :style="{'width': rableTitle[6].width + 'px'}" >
				{{tableSumData.cpm || 0}}
			</div>
			<!-- 点击数 -->
			<div  v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[7].width + 'px'}">
				{{tableSumData.click || 0}}
			</div>
			<!-- 平均点击单价 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[8].width + 'px'}">
				{{tableSumData.cpc || 0}}
			</div>
			<!-- 点击率 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[9].width + 'px'}">
				{{tableSumData.ctr || 0}}
			</div>
			<!-- 微信调起按钮点击量 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[10].width + 'px'}">
				{{tableSumData.weiXinAppButtonConversions || 0}}
			</div>
			<!-- 微信调起按钮点击成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[11].width + 'px'}">
				{{tableSumData.weiXinAppButtonConversionsCost || 0}}
			</div>
			<!-- 微信加粉成功量 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[12].width + 'px'}">
				{{tableSumData.weixinFollowSuccessConversions || 0}}
			</div>
			<!-- 微信加粉成功成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[13].width + 'px'}">
				{{tableSumData.weixinFollowSuccessConversionsCost || 0}}
			</div>
			<!-- 微信复制按钮点击量 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[14].width + 'px'}">
				{{tableSumData.weiXinCopyConversions || 0}}
			</div>
			<!-- 微信复制按钮点击成本 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[15].width + 'px'}">
				{{tableSumData.weiXinCopyConversionsCost || 0}}
			</div>
			
			<!-- 转化数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[16].width + 'px'}">
				{{tableSumData.ocpcTargetTrans || 0}}
			</div>
			<!-- 平均转化成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[17].width + 'px'}">
				{{tableSumData.ocpcTargetTransCPC || 0}}
			</div>
			<!-- 转化率 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[18].width + 'px'}">
				{{tableSumData.ocpcTargetTransRatio || 0}}
			</div>
			<!-- 总充值金额 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[19].width + 'px'}">
				{{tableSumData.eff_total_pay_money || 0}}
			</div>
			<!-- 分成金额 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[20].width + 'px'}">
				{{tableSumData.eff_total_left_money || 0}}
			</div>
			<!-- 首充分成金额 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[21].width + 'px'}">
				{{tableSumData.eff_total_left_money_fisrt || 0}}
			</div>
			<!-- ROI -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[22].width + 'px'}">
				{{tableSumData.eff_roi*100 | tableToFixed}}%
			</div>
			<!-- 首充ROI -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[23].width + 'px'}">
				{{tableSumData.eff_roi_first*100 | tableToFixed}}%
			</div>

			<!-- 当天订单笔数 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[24].width + 'px'}">
				{{tableSumData.eff_total_order_cnt || 0}}
			</div>
			<!-- 当天充值用户数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[25].width + 'px'}">
				{{tableSumData.eff_total_pay_user_cnt || 0}}
			</div>
			<!-- 当天充值用户成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[26].width + 'px'}">
				{{tableSumData.eff_total_pay_user_cost | tableToFixed}}
			</div>
			<!-- ARPU -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[27].width + 'px'}">
				{{tableSumData.arpu | tableToFixed}}
			</div>
			<!-- 回传用户数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[28].width + 'px'}">
				{{tableSumData.eff_report_pay_user_cnt || 0}}
			</div>
			<!-- 回传用户成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[29].width + 'px'}">
				{{tableSumData.eff_report_pay_user_cost | tableToFixed}}
			</div>
			<!-- 账户ID -->
			<div class="table-td-cell" :style="{'width': rableTitle[30].width + 'px'}">
				
			</div>
			<!-- 授权时间 -->
			<div class="table-td-cell" :style="{'width': rableTitle[31].width + 'px'}">
				
			</div>
			<!-- 开发者账户 -->
			<div class="table-td-cell" :style="{'width': rableTitle[32].width + 'px'}">
				
			</div>
			
			
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div class="table-td-cell-sticky" style="display: flex;align-items: center;">
				<!-- 选择 -->
				<div class="table-td-cell" :style="{'width':30 + 'px'}">
					<a-checkbox :checked="item.checked" @change="onChangeCheckbox($event,index)"></a-checkbox>
				</div>
				<!-- 账户名称 -->
				<div  @click='operation(1,item)' class="table-td-cell"
				:style="{'width':rableTitle[0].width + 'px'}" >
					{{item.bd_user_name}}
				</div>
				<!-- 负责人 -->
				<div @click='operation(2,item)' class="table-td-cell"
				:style="{'width':rableTitle[1].width + 'px'}" style="color: #2F88FF;cursor: pointer;">
					<div v-if="item.auth.length > 0" style="display: flex;align-items: center;cursor: pointer;flex-wrap: wrap;">
						<div v-for="(item,index) in item.auth" :key="index" style="color: #2F88FF;margin: 0 7px 3px 0;">
							{{item.admin_name}}
						</div>
					</div>
					<div v-else style="color: #62a8ea;cursor: pointer;">
						未设置
					</div>
				</div>
				<!-- 推广平台 -->
				<div @click='operation(3,item)' class="table-td-cell"
				:style="{'width':rableTitle[2].width + 'px'}" style="color: #62a8ea;cursor: pointer;">
					<div v-if="item.content_channel || item.book_name">
						<div>{{item.content_channel}}</div>
						<div>{{item.book_name}}</div>
					</div>
					<div v-else >
						未设置
					</div>
				</div>
				<!-- 操作 -->
				<div  class="table-td-cell"
				:style="{'width':rableTitle[3].width + 'px'}">
					<a-popover :visible="item.popover_clicked" @visibleChange="handleClickChange($event,item)" trigger="click" placement="bottom">
						<template slot="content">
						  <div>
							  <div @click="zhOperation(3,item)" class='cz-button-calss'>查看计划</div>
							  <div @click="zhOperation(2,item)" class='cz-button-calss'>查看单元</div>
							  <div @click="zhOperation(1,item)" class='cz-button-calss'>同步广告</div>
							  <div @click="zhOperation(5,item)" class='cz-button-calss'>同步历史数据</div>
						  </div>
						</template>
						
						<a-icon style="font-size: 18px;font-weight: bold;cursor: pointer;" type="more" />
					</a-popover>
					
				</div>
			</div>
			<!-- 消耗 -->
			<div class="table-td-cell"  :class="{'text-right': rableTitle[4].text_right}" :style="{'width': rableTitle[4].width + 'px'}">
				{{item.cost || 0}}
			</div>
			<!-- 展示数 -->
			<div v-show="!jj_checked" class="table-td-cell" :class="{'text-right': rableTitle[5].text_right}"  :style="{'width': rableTitle[5].width + 'px'}">
				{{item.impression || 0}}
			</div>
			<!-- ecpm -->
			<div v-show="!jj_checked" class="table-td-cell" :class="{'text-right': rableTitle[6].text_right}" :style="{'width': rableTitle[6].width + 'px'}" >
				{{item.cpm || 0}}
			</div>
			<!-- 点击数 -->
			<div  v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[7].width + 'px'}">
				{{item.click || 0}}
			</div>
			<!-- 平均点击单价 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[8].width + 'px'}">
				{{item.cpc || 0}}
			</div>
			<!-- 点击率 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[9].width + 'px'}">
				{{item.ctr || 0}}
			</div>
			<!-- 微信调起按钮点击量 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[10].width + 'px'}">
				{{item.weiXinAppButtonConversions || 0}}
			</div>
			<!-- 微信调起按钮点击成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[11].width + 'px'}">
				{{item.weiXinAppButtonConversionsCost || 0}}
			</div>
			<!-- 微信加粉成功量 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[12].width + 'px'}">
				{{item.weixinFollowSuccessConversions || 0}}
			</div>
			<!-- 微信加粉成功成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[13].width + 'px'}">
				{{item.weixinFollowSuccessConversionsCost || 0}}
			</div>
			<!-- 微信复制按钮点击量 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[14].width + 'px'}">
				{{item.weiXinCopyConversions || 0}}
			</div>
			<!-- 微信复制按钮点击成本 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[15].width + 'px'}">
				{{item.weiXinCopyConversionsCost || 0}}
			</div>
			<!-- 转化数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[16].width + 'px'}">
				{{item.ocpcTargetTrans || 0}}
			</div>
			<!-- 平均转化成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[17].width + 'px'}">
				{{item.ocpcTargetTransCPC || 0}}
			</div>
			<!-- 转化率 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[18].width + 'px'}">
				{{item.ocpcTargetTransRatio || 0}}
			</div>
			<!-- 总充值金额 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[19].width + 'px'}">
				{{item.eff_total_pay_money || 0}}
			</div>
			<!-- 分成金额 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[20].width + 'px'}">
				{{item.eff_total_left_money || 0}}
			</div>
			<!-- 首充分成金额 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[21].width + 'px'}">
				{{item.eff_total_left_money_fisrt || 0}}
			</div>
			<!-- ROI -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[22].width + 'px'}">
				{{item.eff_roi*100 | tableToFixed}}%
			</div>
			<!-- 首充ROI -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[23].width + 'px'}">
				{{item.eff_roi_first*100 | tableToFixed}}%
			</div>
			<!-- 当天订单笔数 -->
			<div v-show="!jj_checked" class="table-td-cell text-right" :style="{'width': rableTitle[24].width + 'px'}">
				{{item.eff_total_order_cnt || 0}}
			</div>
			<!-- 当天充值用户数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[25].width + 'px'}">
				{{item.eff_total_pay_user_cnt || 0}}
			</div>
			<!-- 当天充值用户成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[26].width + 'px'}">
				{{item.eff_total_pay_user_cost | tableToFixed}}
			</div>
			<!-- ARPU -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[27].width + 'px'}">
				{{item.arpu | tableToFixed}}
			</div>
			<!-- 回传用户数 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[28].width + 'px'}">
				{{item.eff_report_pay_user_cnt || 0}}
			</div>
			<!-- 回传用户成本 -->
			<div class="table-td-cell text-right" :style="{'width': rableTitle[29].width + 'px'}">
				{{item.eff_report_pay_user_cost | tableToFixed}}
			</div>
			<!-- 账户ID -->
			<div class="table-td-cell" :style="{'width': rableTitle[30].width + 'px'}">
				{{item.bd_user_id}}
			</div>
			<!-- 授权时间 -->
			<div class="table-td-cell" :style="{'width': rableTitle[31].width + 'px'}">
				{{item.created_at}}
			</div>
			<!-- 开发者账户 -->
			<div class="table-td-cell" :style="{'width': rableTitle[32].width + 'px'}">
				{{item.admin_account_name}}
			</div>
			
			
		</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px auto 50px;">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
		
	</div>
</template>

<script>
export default {
	name: 'BDzhTable',
	props: ['rableTitle','tableShowData','tableSumData','table_scroll_width','jj_checked','indeterminate','checkAll'],
	data(){
		return {
			
			select_sort_index: "", // 筛选的
			
			popover_clicked: false,
			
			sticky_index: 3,
		}
	},
	methods: {
		sortClick(index){ // 点击表头给内容进行排序
			let that = this
			let th_status // 0是默认，1是箭头向下，2是箭头向上
			console.log(that.rableTitle[index].type)
			if(that.rableTitle[index].sort_control){ // 是否有排序功能
				if(index !== this.select_sort_index){
					this.select_sort_index = index
					that.rableTitle.forEach(res=>{
						res.sort_status = 0
					})
					that.rableTitle[index].sort_status = 1
					th_status = 1
				}
				else { // 点击的是同一个表头
					if(that.rableTitle[index].sort_status === 0){
						that.rableTitle[index].sort_status = 1 // 箭头向下
						th_status = 1
					}
					else if(that.rableTitle[index].sort_status === 1){
						that.rableTitle[index].sort_status = 2 // 箭头向上
						th_status = 2
					}
					else if(that.rableTitle[index].sort_status === 2){
						that.rableTitle[index].sort_status = 0
						th_status = 0
					}
				}
				
				
				
				this.$emit('table-th-click', index, th_status, that.rableTitle[index].type)
			}
		},
		// editTable(index){
		// 	this.$emit('edit-td-click', index)
		// },
		// 操作
		operation(e,item){
			// console.log(e)
			if(e == 1){ // 点击账户名称
				
			}
			else if(e == 2){ // 点击负责人
				this.$emit('click-Fzr', item)
			}
			else if(e == 3){ // 推广内容
				this.$emit('click-tgnr', item)
			}
		},
		handleClickChange(e,item){
			console.log(e)
			item.popover_clicked = e
		},
		// 表格内的操作项
		zhOperation(e,item){
			console.log(item)
			if(e == 1){ // 同步广告
				item.popover_clicked = false
				this.$emit('sync-zhxx-click', item,1)
			}
			else if(e == 3){ // 查看计划
				this.$router.push({name:'BDjh_',params:{jump_id:item.bd_user_id}})
			}
			else if(e == 2){ // 查看单元
				this.$router.push({name:'BDdy_',params:{j_adv_id:item.bd_user_id}})
			}
			// else if(e == 4){ // 同步账户信息
			// 	item.popover_clicked = false
			// 	this.$emit('sync-zhxx-click', item, 4)
			// }
			else if(e == 5){ // 同步历史数据
				item.popover_clicked = false
				this.$emit('sync-zhxx-click', item, 5)
			}
		},
		
		// 全选
		onCheckAllChange(e){
			this.$emit('click-All-Checkbox', e)
		},
		// 单选
		onChangeCheckbox(checkedList,index){
			this.$emit('click-Checkbox', checkedList,index)
		},
	},
	filters: {
		bookTypeFilters(value){
			// console.log("过滤器",value)
			let vvv 
			if(value === 0){
				vvv = "未设置"
			}
			else if(value === 1){
				vvv = "男频"
			}
			else if(value === 2){
				vvv = "女频"
			}
			return vvv
		},
		tableToFixed(value){ // 保留小数点后两位，四舍五入
			// console.log("过滤器",value)
			if(value){
				let v = Number(value)
				return v.toFixed(2)
			}
			else {
				return 0
			}
			
		}
	}
}
</script>

<style scoped>
.cz-button-calss {
	font-size: 13px;
	padding:10px;
	cursor: pointer;
}
.cz-button-calss:hover {
	background-color: #f4f7fa;
}

/* 表格样式-非公共/基础样式 */
.table-th-cell {
	height: 59px;
}
.table-th-cell:hover {
	background-color: #eee;
}
.table-th-cell:hover .table-th-cell-sticky{
	background-color: #eee;
}

.table-td-cell {
	font-size: 12px;
}
</style>